import createVueComponent from '../createVueComponent';

const CornerUpRight = createVueComponent('CornerUpRightIcon', [
  ['polyline', { points: '15 14 20 9 15 4', key: '1tbx3s' }],
  ['path', { d: 'M4 20v-7a4 4 0 0 1 4-4h12', key: '1lu4f8' }],
]);

export default CornerUpRight;
